import React, { useEffect } from 'react';
import StipulationsPageMain from '../../presentation/section/footer-link-page/StipulationsPageMain';

const Stipulations = (props) => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  return (
    <StipulationsPageMain />
  )
}

export default Stipulations;